// Sortable
import { moveItemInList } from 'mdb-sortable';
// tables
import {
  Component, OnInit, ElementRef, HostListener,
  AfterViewInit, ViewChild, ChangeDetectorRef,
  QueryList, ViewChildren
} from '@angular/core';
import { MdbTableDirective, MdbTablePaginationComponent, MdbBtnDirective, MDBModalRef } from 'ng-uikit-pro-standard';
// mensage type  toast
import { ToastService } from 'ng-uikit-pro-standard';
// forms and validations
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { ComponentsType, ComponentIndicator, ComponentChart, ChartDatasets, ChartColors, Dashboard } from 'src/app/models/component-data';
import { DasboardService } from 'src/app/services/dashboard.service';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { groupBy, mergeMap, toArray } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import { GetTypePipe } from 'src/app/custom-pipe/GetTypePipe';
import { AppConfigService } from 'src/app/app-config.service.service';
import { IMyOptions } from 'ng-uikit-pro-standard';
import { CurrencyPipe, DatePipe } from '@angular/common';

import { DxDataGridModule, DxButtonModule, DxDataGridComponent, DxDropDownButtonModule } from 'devextreme-angular';
import { exportDataGrid as exportDataGridToPdf } from 'devextreme/pdf_exporter';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';


@Component({
  selector: 'app-shared-dashboard',
  templateUrl: './shared-dashboard.component.html',
  styleUrls: ['./shared-dashboard.component.scss']
})
export class SharedDashboardComponent implements OnInit, AfterViewInit {
  @ViewChildren(MdbBtnDirective, { read: ElementRef }) buttons: QueryList<ElementRef>;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable: MdbTableDirective;
  @ViewChild(MdbTableDirective, { static: true }) mdbTable3: MdbTableDirective;
  @ViewChild(MdbTablePaginationComponent, { static: true }) mdbTablePagination: MdbTablePaginationComponent;
  @ViewChild('row', { static: true }) row: ElementRef;
  @ViewChild('createDashboard', { static: true }) createDashboard;
  @ViewChild('mdelete', { static: true }) mdelete;
  @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;
  // @ViewChildren(MdbBtnDirective, { read: ElementRef }) buttons: QueryList<ElementRef>;
  elements2: any = [];
  statuses: Array<any>;
  RInterval: Array<any>;
  dataorigen: Array<any>;
  iX: Array<any>;
  iY: Array<any>;
  categories: Array<any> = [];
  disabledElements: any[];
  components: Array<ComponentsType> = new Array<ComponentsType>();
  componentsToAdd: Array<ComponentsType> = new Array<ComponentsType>();
  componentsTypes: any;
  dashboards: any;
  selectedDashboard: number;
  nameDashboardSelected: string;
  newDashboard: Dashboard = new Dashboard();
  textFilterComponent: string;
  chartType = 'doughnut';
  dashBoardForm: FormGroup;
  optionsCType = [];

  videoDashboardSelected: string;
  videoDashboardUnSelected: string;

  editingDashboard = false;

  cancelButton:any;
  saveButton:any;

  public myDatePickerOptions: IMyOptions = {
    // Your options
  };

  public chartDatasets: Array<any> = [
    { data: [100, 50, 0, 0], label: 'My First dataset' }
  ];

  public activeLang = 'en';

  public chartLabels: Array<any> = ['Material Cost', 'Labor Cost', 'Subcontrator', 'Expensive Report'];

  public chartColors: Array<any> = [
    {
      backgroundClass: ['flex-rectangleRed', 'flex-rectangleGreen', 'flex-rectangleOrange', 'flex-rectangleBlue'],
      backgroundColor: ['#95c83d', '#F7464A', '#F9A21B', '#12A5DD'],
      hoverBackgroundColor: ['#95c83d', '#F7464A', '#F9A21B', '#12A5DD'],
      borderWidth: 2,
    }
  ];

  popupCreateDashboard = false;
  popupAddComponent = false;
  popupDeleteDashbord = false;

  public chartOptions: any = {
    responsive: true
  };

  public chartType1 = 'pie';

  public chartDatasets1: Array<any> = [
    { data: ['50', '50'], label: 'My First dataset' }
  ];
  public chartLabels1: Array<any> = ['Billable', 'Non Billable'];
  public chartColors1: Array<any> = [
    {
      backgroundClass: ['flex-rectangleRed', 'flex-rectangleGreen'],
      backgroundColor: ['#F7464A', '#95C83D'],
      hoverBackgroundColor: ['#F7464A', '#95C83D'],
      borderWidth: 2,
    }
  ];
  public chartOptions1: any = {
    responsive: true
  };

  headElements2 = [{ head: '', id: 'EstimateId', class: 'text-right' },
  { head: 'Cost Category', id: 'ProjectName', class: 'text-left' },
  { head: 'Total Cost', id: 'hours', class: 'text-right' }
  ];



  // disable objects sortable
  ngAfterViewInit() {
    const buttons = this.buttons.toArray();

    this.componentsTypes = environment.DashboardComponentsType;
    setTimeout(() => {
      this.disabledElements = buttons.map(button => button.nativeElement);
    }, 0);

    // this.newDashboard.dashboardSize = 1;


  }


  onListReorder(e) {
    console.log(e);
    let fromindex = e.fromIndex + 1;
    let toindex = e.toIndex + 1;
    let primer = this.components.find(x => x.componentOrder == fromindex);
    let segundo = this.components.find(x => x.componentOrder == toindex);

    primer.componentOrder = toindex;
    segundo.componentOrder = fromindex;
    // moveItemInList(this.components, event.oldIndex, event.newIndex);
    // for (let index = 0; index < this.components.length; index++) {
    //   this.components[index].componentOrder = index + 1;
    //   this.components[index].DashboardId = this.selectedDashboard;
    // }

    this.saveChangeComponents();
    this.components.splice(e.toIndex, 0, this.components.splice(e.fromIndex, 1)[0]);

    // const component1 = this.components.splice(e.fromIndex, 1)[0];
    // const component2 = this.components.splice(e.toIndex, 1)[0];

    // this.components.splice(e.toIndex, 0, component1);
    // this.components.splice(e.fromIndex, 0, component2);
  }

  onTaskDragStart(e) {
    e.itemData = e.fromData[e.fromIndex];
  }

  onTaskDrop(e) {
    e.fromData.splice(e.fromIndex, 1);
    e.toData.splice(e.toIndex, 0, e.itemData);
  }

  mouseEnter(item) {
    item.disabled = true;
  }

  mouseLeave(item) {
    item.disabled = false;
  }

  public chartClicked(e: any): void { }
  public chartHovered(e: any): void { }

  public chartClicked1(e: any): void { }
  public chartHovered1(e: any): void { }

  // tslint:disable-next-line: member-ordering
  dateFormat = 'dd-MM-yyyy';
  moneyFormat = '';
  /////// message tost
  constructor(
    private toastrService: ToastService,
    private dashboardService: DasboardService,
    translate: TranslateService,
    private currencyPipe: CurrencyPipe,
    private datePipe: DatePipe,
    private translateService: TranslateService,
    // private translatePipe: TranslatePipe,
    private appConfigService: AppConfigService) {
    translate.setDefaultLang(this.activeLang);

    if (!appConfigService.appConfig) {
      appConfigService.loadAppConfig()
    }
    this.dateFormat = this.appConfigService.dateFormat;
    this.moneyFormat = this.appConfigService.moneyFormat;

    this.videoDashboardSelected = this.appConfigService.videoDashboardSelected;
    this.videoDashboardUnSelected = this.appConfigService.videoDashboardUnSelected;


    this.elements2.push({ EstimateId: '1', ProjectName: 'Material Cost', hours: '6,299.52' });
    this.elements2.push({ EstimateId: '2', ProjectName: 'Labor Cost', hours: '421,658.21' });
    this.elements2.push({ EstimateId: '3', ProjectName: 'Subcontrator', hours: '0.00' });
    this.elements2.push({ EstimateId: '4', ProjectName: 'Expense Report', hours: '0.00' });
    this.setForm();


    this.cancelButton = {
      text: 'Cancel',
      elementAttr: {
        id: 'bton-gray'
      },
      onClick: () => {
        this.setForm();
        this.popupCreateDashboard = false;
      },
    };


    this.saveButton = {
      text: 'Save',
      icon: 'check',
      elementAttr: {
        id: 'bton-green'
      },
      onClick: () => {
        this.saveDashboard(this.dashBoardForm.value);
      },
    };
  }

  setForm() {
    this.editingDashboard = false;
    this.dashBoardForm = new FormGroup({
      name: new FormControl('', [
        Validators.required,
        Validators.minLength(1),
        Validators.maxLength(30)
        // forbiddenNameValidator(/bob/i) // <-- Here's how you pass in the custom validator.
      ]),
      description: new FormControl('', [
        // Validators.required,
        Validators.maxLength(50)
        // forbiddenNameValidator(/bob/i) // <-- Here's how you pass in the custom validator.
      ]),
      dashboarddefault: new FormControl(false, []),
    });
  }

  ngOnInit() {

    const interval = setInterval(() => {
      if (sessionStorage.getItem('moduleId')) {
        clearInterval(interval);
        this.getDashboards();
      }
    }, 500);

  }

  // showSuccess() {
  //   const options = {closeButton: true,actionButton: 'Action',tapToDismiss: true, toastClass: 'opacity: 1 ' };
  //   this.toastrService.success('Added Successfully', options);
  // }

  // showWarning() {
  //   const options = { progressBar: true, timeOut: 3000, toastClass: 'black' };
  //   this.toastrService.warning('Warnig message', 'Toastr warning!', options);
  // }

  deleteDashboard() {
    this.dashboardService.deleteDashboard(this.selectedDashboard).subscribe(result => {
      this.popupDeleteDashbord = false;;
      this.toastrService.success('Deleted Successfully');
      this.getDashboards();
    });
  }

  saveDashboard(item) {

    if (this.editingDashboard) {
      item.id = this.selectedDashboard;
      this.dashboardService.updateDashboard(item).subscribe(result => {
        // console.log('update', result);
        // let idx = this.categories.findIndex(x => x.value == this.selectedDashboard);
        // this.categories[idx].label = item.name;
        this.toastrService.success('Dashboad modified successfully.');
        this.popupCreateDashboard = false;
        this.setForm();
        this.getDashboards();
      });
    } else {

      this.dashboardService.newDashboard(item).subscribe(result => {
        // const options = { progressBar: true, timeOut: 3000,tapToDismiss: false,  toastClass: 'bg-white', messageClass: 'gray',titleClass: 't-gray'  };
        // this.toastrService.success('Hello world!', 'Toastr success!', options);
        const options = { progressBar: true, timeOut: 3000, opacity: 1 };
        this.toastrService.success('Added Successfully', '', options);
        this.popupCreateDashboard = false;
        this.getDashboards();
        this.setForm();
      });
    }

  }

  addNewComponent(item: ComponentsType) {
    // item.serviceEndPoint = null;
    // this.components.push(item);
    const orders = this.components.map(x => x.componentOrder);

    if (orders.length == 0) {
      item.componentOrder = 1;
    } else {
      const maxOrder = Math.max(...orders);
      item.componentOrder = maxOrder + 1;
    }

    this.components.push(item);
    this.getDataComponents(false, item);
    const obj = {
      dashboardid: this.selectedDashboard,
      componentid: item.componentID,
      componentorder: item.componentOrder
    };

    this.dashboardService.addNewComponentDashboard(obj).subscribe(result => {
      // console.log('save component dashboard', result);
    });
  }

  removeAlerts() {
    this.toastrService.clear();
  }

  onDrop(event: any) {
    moveItemInList(this.components, event.oldIndex, event.newIndex);
    for (let index = 0; index < this.components.length; index++) {
      this.components[index].componentOrder = index + 1;
      this.components[index].DashboardId = this.selectedDashboard;
    }

    this.saveChangeComponents();
  }

  saveChangeComponents() {
    this.dashboardService.UpdateDashBoardComponents(this.selectedDashboard, this.components).subscribe(result => {
      //this.ngOnInit();
      console.log('update', result);
    });
  }

  sumArrayNumber(array: any) {
    const sum = array.reduce((sum, current) => sum + current.total, 0);
    return sum;
  }

  populateData(component, data: any) {
    let chartType = '';
    switch (component.componentTypeID) {
      case 1:
        // console.log('table', data);

        // data = JSON.parse('[{"numid":14,"strCoName":"Earthsmart controls","strdbname":"cube00000013","datlastlogin":"2021-03-26t21:34:52.677","strlastuser":"earthsmartcontrols@cube-usa.com","numNumbOfDays":5},{"numid":50,"strCoName":"Delta Integrated Building Solutions inc","strdbname":"cube00000039","datlastlogin":"2021-03-26t21:37:06.227","strlastuser":"dibs@cube.com","numNumbOfDays":5},{"numid":55,"strCoName":"ESC Automation inc","strdbname":"cube00000044","datlastlogin":"2021-03-26t20:40:16.58","strlastuser":"esctoronto@cube-usa.com","numNumbOfDays":5},{"numid":60,"strCoName":"Arizona Control Specialists, inc.","strdbname":"cube00000049","datlastlogin":"2021-03-26t21:28:53.433","strlastuser":"azs@cube-usa.com","numNumbOfDays":5},{"numid":70,"strCoName":"Ambient Mechanical ltd.","strdbname":"cube00000060","datlastlogin":"2021-03-26t17:21:52.663","strlastuser":"aturola@acesolutionsgroup.ca","numNumbOfDays":5},{"numid":64,"strCoName":"Delta Connects (2), inc.","strdbname":"cube00000053","datlastlogin":"2021-03-29t11:32:17.427","strlastuser":"deltac3@cube-usa.com","numnumbofdays":2},{"numid":66,"strconame":"mikkelsen-coward","strdbname":"cube00000055","datlastlogin":"2021-03-30t21:33:00.623","strlastuser":"tbenson","numNumbOfDays":1},{"numid":68,"strCoName":"Serv-All Mechanical Services ltd.","strdbname":"cube00000058","datlastlogin":"2021-03-30t20:12:00.847","strlastuser":"douellette@serv-all.ca","numNumbOfDays":1},{"numid":72,"strCoName":"Delaware Valley automation","strdbname":"cube00000062","datlastlogin":"2021-03-30t21:40:05.333","strlastuser":"hweitzner@dvautomate.com","numNumbOfDays":1},{"numid":73,"strCoName":"Twin Rivers controls","strdbname":"cube00000064","datlastlogin":"2021-03-30t21:46:37.677","strlastuser":"jlarson@trcontrols.ca","numNumbOfDays":1},{"numid":61,"strCoName":"Tampa Bay trane","strdbname":"cube00000050","datlastlogin":"2021-03-30t23:18:24.997","strlastuser":"david.painter@trane.com","numnumbofdays":1},{"numid":62,"strconame":"u.s. Engineering service","strdbname":"cube00000051","datlastlogin":"2021-03-30t20:15:32.513","strlastuser":"michael.burr@usengineering.com","numNumbOfDays":1},{"numid":6,"strCoName":"Travis Brothers Building automation","strdbname":"cube00000006","datlastlogin":"2021-03-30t18:54:32.383","strlastuser":"dan.travis@travisbrothers.com","numNumbOfDays":1},{"numid":56,"strCoName":"Controls and equipment","strdbname":"cube00000045","datlastlogin":"2021-03-30t18:55:21.917","strlastuser":"mjones@controlsequipment.com","numnumbofdays":1},{"numid":52,"strconame":"enervise","strdbname":"cube00000041","datlastlogin":"2021-03-30t13:07:58.637","strlastuser":"mjacobus","numNumbOfDays":1},{"numid":37,"strCoName":"Metropolitan Mechanical Contractors, inc.","strdbname":"cube00000009","datlastlogin":"2021-03-30t12:52:39.1","strlastuser":"sam.johnson@metromech.us","numNumbOfDays":1},{"numid":41,"strCoName":"Ecosave automation","strdbname":"cube00000028","datlastlogin":"2021-03-30t17:41:28.127","strlastuser":"akhachaturian@ecosaveinc.com","numNumbOfDays":1},{"numid":20,"strCoName":"Delta Connects, inc.","strdbname":"cube00000017","datlastlogin":"2021-03-30t23:11:39.05","strlastuser":"hlittman@deltaconnects.com","numNumbOfDays":1},{"numid":25,"strCoName":"Shasta Control company","strdbname":"cube00000019","datlastlogin":"2021-03-30t23:22:53.68","strlastuser":"todd@shastacontrolcompany.com","numNumbOfDays":1},{"numid":27,"strCoName":"Newmatic engineering","strdbname":"cube00000022","datlastlogin":"2021-03-31t00:06:31.007","strlastuser":"nghotbi@newmatic.net","numNumbOfDays":0},{"numid":31,"strCoName":"Automated Comfort Controls, inc.","strdbname":"cube00000025","datlastlogin":"2021-03-31t00:53:30.537","strlastuser":"pkreiling@automatedcomfort.com","numNumbOfDays":0},{"numid":16,"strCoName":"Energy Control inc","strdbname":"cube00000016","datlastlogin":"2021-03-31t00:14:28.527","strlastuser":"claro.calaunan@engie.com","numNumbOfDays":0},{"numid":1,"strCoName":"South Florida controls","strdbname":"cube","datlastlogin":"2021-03-31t03:17:46.713","strlastuser":"jgarit@sfc-mia.com","numnumbofdays":0},{"numid":4,"strconame":"cube-usa","strdbname":"cube00000004","datlastlogin":"2021-03-31t02:09:33.723","strlastuser":"hector2","numNumbOfDays":0},{"numid":48,"strCoName":"Automated Controls, inc.","strdbname":"cube00000037","datlastlogin":"2021-03-31t03:59:10.613","strlastuser":"jjudy@automatedcontrols.net","numNumbOfDays":0},{"numid":39,"strCoName":"HCT Control technology","strdbname":"cube00000018","datlastlogin":"2021-03-31t03:28:24.83","strlastuser":"mfiebiger@mailhvac.com","numNumbOfDays":0},{"numid":69,"strCoName":"TES controls","strdbname":"cube00000059","datlastlogin":"2021-03-31t01:47:28.45","strlastuser":"konner@tescontrols.com","numNumbOfDays":0}]')


        component.data = data;



        let columns = [];
        let names = Object.keys(data[0]);
        let mythis = this;
        names.forEach(element => {
          let traduction: any = this.translateService.get(element);
          let datatype = 'string';
          let obj = {
            columnAutoWidth: true,
            dataField: element,
            caption: traduction.value.replace('ico_', ''), // element.substr(3, element.length - 1),
            // caption: this.translatePipe.transform(element), //  element.substr(3, element.length - 1),
            dataType: 'string',
            cellTemplate: function (element, info) {
              let html = '';
              let initial = names[info.columnIndex].substr(0, 3);
              let val = info.data[names[info.columnIndex]];

              if (initial == 'hyp') {
                html = '<span> <a href=' + val + ' target="_blank"><i class="fa fa-link"></i> View link</a></span>';
              }

              else if (initial == 'ico') {
                html = '<span><i class="' + val + '"></i></span>';
              }

              else if (initial == 'str' || initial == 'boo') {
                html = '<span>' + val + '</span>';
              }

              else if (initial == 'cur') {
                datatype = 'number';
                html = '<span>' + mythis.currencyPipe.transform(val, mythis.moneyFormat) + '</span>'
              }

              else if (initial == 'dat') {
                datatype = 'date';
                html = '<span>' + mythis.datePipe.transform(val, mythis.dateFormat) + '</span>'
              } else if (initial == 'num') {
                datatype = 'number';
                val = val == null || val == undefined ? '' : val;
                html = '<span>' + val + '</span>';

              }

              else {
                html = '<span>' + val + '</span>';
              }
              obj.dataType = datatype;

              // html = '<div style="color: red">' + val + "</div>";
              element.innerHTML = html;
              // .style("color", "red");


            }
          }
          columns.push(obj);
        });

        component.columns = columns;
        // const pipe = new GetTypePipe();
        // const fiteredArr = pipe.transform(data, ['1']);
        // console.log('prueba final2', JSON.stringify(data));
        // console.log('prueba final', fiteredArr);
        break;
      case 2:
      case 3:
      case 4:
      case 5:
      case 6:
      case 9:
      case 10:
        if (component.componentTypeID === 2) {
          chartType = 'doughnut';
        }
        else if (component.componentTypeID === 3) {
          chartType = 'pie';
        }
        else if (component.componentTypeID === 4) {
          chartType = 'bar';
        }
        else if (component.componentTypeID === 5) {
          chartType = 'horizontalBar';
        }
        else if (component.componentTypeID === 6) {
          chartType = 'bar';
        }
        else if (component.componentTypeID === 9) {
          chartType = 'line';
        }
        else if (component.componentTypeID === 10) {
          chartType = 'radar';
        }
        // console.log('grafico', data);
        const chart = new ComponentChart();
        const dataset1 = new ChartDatasets();

        chart.chartType = chartType;
        chart.chartOptions = {
          responsive: true,
        };

        if (component.componentTypeID == 6) {
          chart.chartOptions = {
            responsive: true,
            scales: {
              xAxes: [{
                stacked: true
              }],
              yAxes: [
                {
                  stacked: true
                }
              ]
            }
          };
        }


        if (component.componentTypeID == 9 || component.componentTypeID == 6 || component.componentTypeID == 10) {
          const source: Observable<any> = from(data);
          // group by age
          const example = source.pipe(
            groupBy(person => person.chartDataName),
            // return each item in group as array
            mergeMap(group => group.pipe(toArray()))
          );

          const arrays = [];
          const subscribe = example.subscribe(val => {
            let datasetn = new ChartDatasets();

            arrays.push(val);
            val.forEach(ele => {
              // chart.chartLabels.push(ele.chartlabel);
              datasetn.data.push(ele.chartValue);
            });

            datasetn.label = val[0].chartDataName;
            chart.chartDatasets.push(datasetn);

          });

          arrays[0].forEach(element => {
            chart.chartLabels.push(element.chartlabel);
          });

          chart.chartColors = [
            {
              backgroundColor: 'rgba(105, 0, 132, .2)',
              borderColor: 'rgba(200, 99, 132, .7)',
              borderWidth: 2,
              backgroundClass: '',
              hoverBackgroundColor: ''
            },
            {
              backgroundColor: 'rgba(0, 137, 132, .2)',
              borderColor: 'rgba(0, 10, 130, .7)',
              borderWidth: 2,
              backgroundClass: '',
              hoverBackgroundColor: ''
            }
          ];

        } else {
          data.forEach(element => {
            chart.chartLabels.push(element.chartlabel);
            dataset1.data.push(element.chartValue);
          });
          dataset1.label = 'Dataset for doughnut';
          chart.chartDatasets.push(dataset1);
        }


        chart.chartColors.push(new ChartColors());
        component.data = chart;
        break;
      case 7:
      case 8:
        // console.log('indicator', data);
        component.data = data[0];
        break;

    }
  }

  GetAllDashboardComponents() {
    this.dashboardService.GetALlDashboardComponents().subscribe(result => {
      this.componentsToAdd = result;
      // console.log('GetALlDashboardComponents CRUDOS', result);
      // console.log('GetALlDashboardComponents', this.componentsToAdd);
    });
  }

  editDashboard() {
    this.editingDashboard = true;
    console.log(this.selectedDashboard);
    let dash = this.dashboards.find(x => x.dashboardID == this.selectedDashboard);
    this.dashBoardForm.controls['name'].setValue(dash.name);
    this.dashBoardForm.controls['description'].setValue(dash.description);
    this.dashBoardForm.controls['dashboarddefault'].setValue(dash.dashboardDefault);
  }

  changeDashboard(item) {
    this.nameDashboardSelected = this.categories.find(x => x.value == item).label;
    this.dashboardService.getDashboardById(item).subscribe(result => {
      // sort for organize components by orders
      this.components = result.sort(
        function (a, b) {
          return a.componentOrder - b.componentOrder;
        });

      // let testComponent = new ComponentsType();
      // testComponent.DashboardId = 3;
      // testComponent.colLayoutBig = 4;
      // testComponent.colLayoutSmall = 12;
      // testComponent.componentOrder = 1;
      // testComponent.componentTitle = 'prueba';
      // testComponent.componentTypeID = 2;
      // this.components.push(testComponent);

      // tslint:disable-next-line: prefer-for-of
      for (let index = 0; index < this.components.length; index++) {
        this.components[index].DashboardId = this.selectedDashboard;
      }

      // console.log('components', this.components);
      this.getDataComponents();
    });
  }

  getDataComponents(isArray = true, item = null) {
    if (isArray) {
      this.components.forEach(element => {
        if (element.componentID) {
          this.dashboardService.getData(element.componentID).subscribe(result => {
            // console.log(result);
            this.populateData(element, result);
          });
        }
      });
    } else {
      if (item.componentID) {
        this.dashboardService.getData(item.componentID).subscribe(result => {
          this.populateData(item, result);
        });
      }
    }


  }

  getDashboards() {
    this.GetAllDashboardComponents();
    this.dashboardService.getDashboard().subscribe(result => {
      // console.log('getdassss', result);
      this.categories = [];
      this.dashboards = result;

      result.forEach(element => {
        // this.categories.push({ value: element.dashboardID, label: element.name });
        this.categories = [...this.categories, { value: element.dashboardID, label: element.name }];
      });

      const dashboardselect = result.find(x => x.dashboardDefault == true);
      if (dashboardselect) {
        this.selectedDashboard = dashboardselect.dashboardID;
        this.changeDashboard(this.selectedDashboard);
      } else if (!dashboardselect && this.categories.length > 0) {
        this.selectedDashboard = result[0].dashboardID;
        this.changeDashboard(this.selectedDashboard);
      }

      // console.log('categories', this.categories);
    });
  }

  onSizeChange(item: ComponentsType, size: number) {
    item.colLayoutBig = size;
    this.saveChangeComponents();
  }

  onRemove(item) {
    const index = this.components.indexOf(item, 0);
    if (index > -1) {
      this.components.splice(index, 1);
      for (let index = 0; index < this.components.length; index++) {
        this.components[index].componentOrder = index + 1;
        this.components[index].DashboardId = this.selectedDashboard;
      }
    }
    this.saveChangeComponents();
  }

  handleClick(event: Event) {
    alert('Prueba');
  }

  exportGrid(grid) {
    // console.log(grid)
    // console.log(this.dataGrid)
    // console.log(grid.instance)
    // console.log(this.dataGrid.instance)
    const doc = new jsPDF();
    exportDataGridToPdf({
      jsPDFDocument: doc,
      component: grid.instance
    }).then(() => {
      doc.save('Customers.pdf');
    })
  }

  //tabla anidada project labor

  elements: any = [
    {
      id: 'AutoCAD as-builting',
      first: '4.00',
      last: '24.00',
      handle: '0.00',
      handle5: '0.00',
      handle6: '0.00',
      handle7: '0.00',
      handle8: '0.00',
      collapsed: true,
      masterDetail: [{ orderDate: '0.00', adress: '0.00', adress4: '0.00', adress5: '0.00', adress6: '0.00', adress7: '0.00', adress8: '0.00' }],
    },
  ];

  headElements = ['Category', 'Actual Capacity', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  masterHeadElements = ['Project Name', '%Completed', 'End Date', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  masterHeadElements2 = ['Task Name', '%Completed', 'Start Date', 'End Date', 'Duration', 'Total Hours', 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug'];


}
